import BrowserCookies from "browser-cookies";
import { makeAutoObservable } from "mobx";

import { EncaInterface } from "../utils/setting";

class AuthStore {
	constructor() {
        makeAutoObservable(this);
    }
	toggleNickname = false
	// 登录注销
	user = null
	login = async() => {
		const [err, res] = await EncaInterface({
			mode: "post",
			name: "login",
			withCredentials: true
		});
		if (!err && res) {
			if (res.code === 200 && res.D_163_SID) {
				this.getUser();
			} else {
				if (res.code === 400 && !res.regDiscuz) {
					this.toggleNickname = true;
				} else {
					alert("登录失败");
				}
			}
		} else {
			alert("登录失败");
		}
	}
	logout = async() => {
		const [err, res] = await EncaInterface({
			mode: "post",
			name: "logout",
			withCredentials: true
		});
		if (!err && res && res.code === 200) {
			this.user = null;
			BrowserCookies.erase("D_163_SID");
			localStorage.removeItem("user");
		} else {
			alert("注销失败");
		}
	}
	// 获取用户信息
	getUser = async() => {
		const [err, res] = await EncaInterface({
			name: "getUser",
			withCredentials: true
		});
		if (!err && res && res.code === 200 && res.info) {
			const { avatar, cookieCreateTime, maxAge, nickname } = res.info;
			const user = { avatar, nickname, overtime: cookieCreateTime + maxAge };
			this.user = user;
			localStorage.setItem("user", JSON.stringify(user));
		} else {
			this.user = null;
			localStorage.removeItem("user");
			alert("登录失败");
		}
	}
	// 设置昵称
	setNickame = async(name) => {
		this.toggleNickname = false;
		if (!name) return;
		const [err, res] = await EncaInterface({
			mode: "post",
			name: "setNickname",
			params: { nickname: name },
			withCredentials: true
		});
		if (!err && res) {
			if (res.code === 200) {
				this.login();
			} else if (res.code === 400) {
				alert("该昵称已被占用");
				this.toggleNickname = true;
			}
		} else {
			alert("昵称设置失败");
			this.toggleNickname = true;
		}
	}
}

const Auth = new AuthStore();
export default Auth;